<script setup lang="ts">
// types
import type { NuxtError } from '#app'
// hooks
import { useErrorPage } from '@hooks/error/use-error-page.hook'
// assets
import errorImage from '@images/404.svg'

defineOptions({
  name: 'PageError',
})

const props = defineProps<{
  error: NuxtError
}>()

const {
  refMeta,
  handleClickHome,
} = useErrorPage({ error: props.error })
</script>

<template>
  <div class="error-page">
    <div class="error-page__image-section">
      <div class="error-page__image-wrapper">
        <img
          class="error-page__image"
          :src="errorImage"
          alt="Error"
        >
      </div>
    </div>
    <div class="error-page__content">
      <h2 class="error-page__title">
        {{ refMeta.title }}
      </h2>
      <div class="error-page__message">
        {{ refMeta.message }}
      </div>
      <button
        class="error-page__btn"
        type="button"
        @click="handleClickHome"
      >
        Go back to home page
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss" src="@scss/pages/error-page.scss" />
